import { render, staticRenderFns } from "./faturasigelengelmeyen.vue?vue&type=template&id=545ccf89&scoped=true&"
import script from "./faturasigelengelmeyen.vue?vue&type=script&lang=js&"
export * from "./faturasigelengelmeyen.vue?vue&type=script&lang=js&"
import style0 from "./faturasigelengelmeyen.vue?vue&type=style&index=0&id=545ccf89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ccf89",
  null
  
)

export default component.exports